import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, loading, user, isAdmin, isEditor } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/staff/login" replace />;
  }

  // Check role-based access
  if (requiredRole === 'admin' && !isAdmin) {
    return <Navigate to="/staff/articles" replace />;
  }
  
  if (requiredRole === 'editor' && !isEditor) {
    return <Navigate to="/staff/articles" replace />;
  }

  return children;
};

export default ProtectedRoute;
